import mitt from "@webcore/core/events/mitt";
import { TrackingStatus } from "@webcore/apps/app.8w";
import { AppMode } from "@/context/AppContext";
import { TransformNode } from "babylonjs";

export type AppEvents = {
  /**
   * add custom app events here
   * e.g.: "app-state-change": (state: string) => void;
   */
  'preview-close': void;
  'preview-share': void;
  'switch-modes': "twin" | "ground" | "image" | "vps";
  'content-positioning': void;
  'xr-ready': void;
  'tracking-status-changed': TrackingStatus;
  'app-mode-changed': AppMode;
  
  'anchor-created': TransformNode;
  'anchor-removed': TransformNode;

  'content-found': { targetName: string };
  'content-hidden': { targetName: string };
  'content-lost': { targetName: string };
  'content-update': { targetName: string };
  'content-visible': { targetName: string };

  '8w-killed': void;
  '8w-initialized': void;
};

const appEvents = mitt<AppEvents>();

export default appEvents;
